import React from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import SEOHead from "@/components/SEOHead";
import StructuredData from "@/components/StructuredData";
import Footer from "@/components/footer";

interface AppContentProps {
  Component: React.ComponentType;
  pageProps: Record<string, unknown>;
  manropeClassName: string;
}

const AppContent: React.FC<AppContentProps> = ({
  Component,
  pageProps,
  manropeClassName,
}) => {
  const router = useRouter();
  const isFrench = router.asPath.startsWith("/fr");
  const shouldIncludeFaqSchema =
    router.pathname === "/" || router.pathname === "/fr";

  return (
    <>
      <Head>
        <title>
          {isFrench
            ? "Featcal | Programmes perte de poids et santé métabolique"
            : "Featcal | Operating system for weight-loss programs"}
        </title>
      </Head>
      <SEOHead />
      <StructuredData includeFaq={shouldIncludeFaqSchema} />

      {/* Skip to main content link for screen readers and keyboard users */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>

      <div className={manropeClassName}>
        <Component {...pageProps} />

        {router.pathname !== "/admin" && router.pathname !== "/start" && (
          <>
            <div className="bg-gradient-to-t from-white to-transparent sticky bottom-0 w-full h-20 z-[50]"></div>
            <Footer />
          </>
        )}
      </div>
    </>
  );
};

export default AppContent;
